(function () {
  if (window.Shopify && Shopify.designMode) return;

  var root = document.getElementById('exposure-page-loader');
  if (!root || root.classList.contains('exposure-page-loader--done')) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var FADE_MS = 380;
  var MAX_WAIT_MS = 3200;

  function finish() {
    root.classList.add('exposure-page-loader--done');
    root.setAttribute('aria-busy', 'false');
    document.documentElement.classList.remove('exposure-page-loader-active');
    root.style.removeProperty('will-change');
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function unlockScroll() {
    document.documentElement.classList.remove('exposure-page-loader-active');
  }

  var FILL_INNER_H = 140;
  var FILL_Y_BOTTOM = 253;

  function paint(v) {
    var t = Math.min(1, Math.max(0, v));
    var s = String(t);
    root.style.setProperty('--cup-fill', s);
    root.style.setProperty('--cup-fill-linear', s);
    var band = document.getElementById('ep-loader-fill-band-rect');
    if (band) {
      var h = FILL_INNER_H * t;
      band.setAttribute('y', (FILL_Y_BOTTOM - h).toFixed(2));
      band.setAttribute('height', h.toFixed(2));
    }
  }

  if (reduceMotion) {
    paint(1);
    unlockScroll();
    setTimeout(finish, 80);
    return;
  }

  var targetFill = 0;
  var displayFill = 0;
  var hideScheduled = false;
  var revealDone = false;
  var rafId = null;
  var maxWaitTimer = null;
  var LERP = 0.14;

  function setTargetMin(v) {
    targetFill = Math.min(1, Math.max(targetFill, v));
    scheduleTick();
  }

  function maybeScheduleHide() {
    if (hideScheduled) return;
    if (targetFill < 1 || displayFill < 0.996) return;
    hideScheduled = true;
    setTimeout(finish, FADE_MS);
  }

  function needsAnimationFrame() {
    if (root.classList.contains('exposure-page-loader--done')) return false;
    if (Math.abs(targetFill - displayFill) >= 0.002) return true;
    if (targetFill >= 1 && displayFill < 0.996) return true;
    if (targetFill >= 1 && displayFill >= 0.996 && !hideScheduled) return true;
    return false;
  }

  function tick() {
    rafId = null;
    if (root.classList.contains('exposure-page-loader--done')) return;

    var delta = targetFill - displayFill;
    if (Math.abs(delta) >= 0.002) {
      displayFill += delta * LERP;
      if (Math.abs(targetFill - displayFill) < 0.002) displayFill = targetFill;
      paint(displayFill);
    } else if (displayFill !== targetFill) {
      displayFill = targetFill;
      paint(displayFill);
    }

    maybeScheduleHide();
    if (needsAnimationFrame()) scheduleTick();
  }

  function scheduleTick() {
    if (rafId !== null) return;
    if (!needsAnimationFrame()) return;
    rafId = requestAnimationFrame(tick);
  }

  function onRevealReady() {
    if (revealDone) return;
    revealDone = true;
    if (maxWaitTimer !== null) {
      clearTimeout(maxWaitTimer);
      maxWaitTimer = null;
    }
    unlockScroll();
    setTargetMin(1);
  }

  function bindRevealReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onRevealReady, { once: true });
    } else {
      onRevealReady();
    }
    maxWaitTimer = setTimeout(onRevealReady, MAX_WAIT_MS);
  }

  setTargetMin(0.05);

  if (document.readyState !== 'loading') setTargetMin(0.22);
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    setTargetMin(0.45);
  }
  if (document.readyState === 'complete') setTargetMin(0.78);

  document.addEventListener('readystatechange', function () {
    if (document.readyState === 'interactive') setTargetMin(0.45);
    if (document.readyState === 'complete') setTargetMin(0.78);
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTargetMin(0.32);
  });

  bindRevealReady();

  window.addEventListener(
    'pageshow',
    function (event) {
      if (event.persisted) onRevealReady();
    },
    { once: true }
  );

  scheduleTick();

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      try {
        var url = new URL(a.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        if (url.pathname === window.location.pathname && url.search === window.location.search)
          return;
      } catch (err) {
        return;
      }
      try {
        sessionStorage.setItem('exposure-page-loader-nav', '1');
      } catch (err2) {}
    },
    { capture: true, passive: true }
  );
})();
